import React from 'react';
import MembershipTab from './components/membership-tab';
import './style.scss'

const MembershipList = () => {
	return <MembershipTab />;
};

export default MembershipList;
